import React from 'react'
import { Helmet } from "react-helmet"
import SetHeader from '../../../_components/_common/Header/SetHeader'
import { withRouter } from "react-router";
import MultiLanguageTranslation from '../../../_components/Translate/MultiLangTranslate'
import './Ourservices.css';
import Subscribe from '../_mainHome/Subscribe';
import ServicesBanner from './ServicesBanner';
import farmer_procrument from '../../../assets/images/farmer_procrument.png';
import assistance from '../../../assets/images/assistance.png';
import exportassistance from '../../../assets/images/exportassistance.png';
import stock from '../../../assets/images/stock.png';
import ServiceContact from './ServiceContact';
import WebFooter from '../../../_components/_webapp/Footer/WebFooter';

class ProcurementFacilitation extends React.Component {
    update = () => {
        this.forceUpdate()
    }

    render() {
        const metaTags = document.getElementsByTagName("meta")
        for (const tag of metaTags) if (tag.name === "description")
            tag.content = "Arya provides on-field farmer quality procurement facilitation of Agri commodities and efficiently manages the procurement process for our valued customers."

        return <React.Fragment>
            <Helmet>
                <title>Procurement Facilitation Of Agri Commodities | Arya</title>
                <meta name="keywords" content="Warehouse near me, paddy warehouse, Maize Warehouse, Sugar warehouse, Wheat warehouse, Soyabean warehouse, Rice warehouse, Cotton warehouse, List your warehouse, Buy sell paddy online, Buy sell maize online, Buy sell pulses online, Buy sell spices online, Get loan on agri products, Get loan on agri commodities, Get finance on your commodities, paddy stock near me, maize Stock near me, Wheat stock near me, Bajra Stock near me, Jowar stock near me, Sugar stock near me, Soybean Stock near me, Cotton stock near me, Rice stock near me" />
            </Helmet>
            <SetHeader active={"home"} history={this.props.history} update={this.update}></SetHeader>

           <ServicesBanner/>
           <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="NA_customBreadcumb"><a href="javascript:void(0);" onClick={() => this.props.history.push('/')}><MultiLanguageTranslation title="Arya.ag" /></a> <span>→</span> <a href="javascript:void(0);" onClick={() => this.props.history.push('/our-services')}><MultiLanguageTranslation title="Services" /></a> <span>→</span><span className="breadcrumb_active"><MultiLanguageTranslation title="Procurement Facilitation" /></span></div>
                    </div>
                </div>
            </div>
            
            <section className="Service_intro">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div class="N_About"><h2><MultiLanguageTranslation title="Procurement Facilitation" /></h2></div>
                            <p><MultiLanguageTranslation title="procrument_page_title_our_expertise_on_commo" /></p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="Service_info wdBG">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 Service_info_desc">
                            <div className="d-flex align-items-center">
                                <img src={stock} alt="Warehousing" className="img-fluid " /> 
                                <h3><MultiLanguageTranslation title="On field farmer" /><br/> <MultiLanguageTranslation title="Procurement" /></h3>
                            </div>
                            <p><MultiLanguageTranslation title="procrument_page_title_one_of_key_strength" /></p>
                        </div>
                        <div className="col-md-6 pl-4">
                            <div className="imageBg even">
                                <img src={farmer_procrument} alt="Warehousing" className="img-fluid " /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="Service_info">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="imageBg odd">
                                <img src={assistance} alt="fumigation" className="img-fluid " /> 
                            </div>
                        </div>
                        <div className="col-md-6 Service_info_desc pl-4">
                            <div className="d-flex align-items-center">
                                <img src={stock} alt="fumigation" className="img-fluid " /> 
                                <h3><MultiLanguageTranslation title="Quality Procurement assistance and monitoring" /></h3>
                            </div>
                            <p><MultiLanguageTranslation title="procrument_page_title_we_assist_the_procurement" /></p>
                        </div>
                        
                    </div>
                </div>
            </section>
            <section className="Service_info wdBG">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 Service_info_desc">
                            <div className="d-flex align-items-center">
                                <img src={stock} alt="Quality" className="img-fluid " />
                                <h3><MultiLanguageTranslation title="Export Assistance" /></h3>
                            </div>
                            <p><MultiLanguageTranslation title="procrument_page_title_we_facilitate_procurement" /></p>
                        </div>
                        <div className="col-md-6">
                            <div className="imageBg even pl-4">
                                <img src={exportassistance} alt="Quality" className="img-fluid " />  
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <ServiceContact/>

            <section className="N_stay_update">
                <div className="container">
                    <div className="row">
                        <Subscribe></Subscribe>
                    </div>
                </div>
            </section>
          
            <WebFooter/>
            {/* <SetFooter headerType={2} homePage={true}></SetFooter> */}
        </React.Fragment>
    }
}

export default withRouter(ProcurementFacilitation)